// extracted by mini-css-extract-plugin
export default {"delWrap":"index__delWrap__XB3sL","title":"index__title__hKZDY","tip":"index__tip__iwH2v","btnWrap":"index__btnWrap__ZcZg6","btn":"index__btn__I2HR7"};